import { render } from "./OrderSourceEditPage.vue?vue&type=template&id=1c756104"
import script from "./OrderSourceEditPage.vue?vue&type=script&lang=js"
export * from "./OrderSourceEditPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__